module.exports = __webpack_public_path__ + "static/media/header-menu-toggle-icon.786cb9b1.svg";